const root = 'importList-importListProduct-generalTab'
const productCollections = `${root}-productCollections`

export const TestId = {
  productName: `${root}-productName`,
  productCollections,
  productCollectionsAutocomplete: `${productCollections}-autocomplete`,
  productCollectionsChip: `${productCollections}-autocompleteCollectionChip`,
  productType: `${root}-productType`,
  productTags: `${root}-productTags`,
  productVendor: `${root}-productVendor`,
}
